module.exports = __webpack_public_path__ + "static/media/company.0a64e437.svg";